<template>
	<div class="code-snippets">
		<ul class="results-list results-list--code-snippets" :id="uid">
			<li
				:id="`${uid}_${index}`"
				class="results-list__item"
				v-for="(snippet, index) in items"
				:key="index"
			>
				<CodeManagerCard
					:id="`${uid}_${index}_snippet`"
					:snippet="snippet"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import CodeManagerCard from './snippets-summary-card';

export default {
	name: 'CodeManagerList',
	components: {
		CodeManagerCard
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Code Manager Results List
    * Can use SCSS variables = TRUE
		* [Table of Contents]
    *
    * BASE
*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/
.code-snippets {
}
</style>
